


































import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    BIcon,
    BIconBoxArrowRight,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class InfographyInPractise extends Vue {
  protected nxtprevInfographyInPractise = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail6.png",
    NextImage: "",
    PrevLink: "/Infographie/Astuces",
    NextLink: "",
  };
}
